import { Stack } from '@ethings/ui-toolkit';
import { FC, PropsWithChildren, ReactNode } from 'react';
import { testid } from '../../util';
import { ResponsiveText } from '../responsive-text';

interface StakeholderCardBaseProps extends PropsWithChildren {
  action?: ReactNode;
  hideRole?: boolean;
  role: string;
}

export const StakeholderCardBase: FC<StakeholderCardBaseProps> = ({ action, children, hideRole, role }) => {
  return (
    <Stack spacing={1} data-testid={testid`stakeholder-${role}-section`} >
      <Stack
        display="flex" flexDirection="row" justifyContent="space-between"
      >
        {!hideRole
          && <ResponsiveText
            data-testid={testid`stakeholder-title-${role}`}
            variant="h6"
            responsiveOptions={{
              minFontSize: '1rem',
              maxFontSize: '1.25rem',
              textLengthThreshold: 20,
            }}
            style={{ textTransform: 'capitalize' }}
          >
            {role}
          </ResponsiveText>
        }
        {action}
      </Stack>
      {children}
    </Stack>
  );
};
